import { getFirstLead } from 'helpers/api/getFirstLead'
import { useEffect } from 'react'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetFirstLead = (): void => {
  const cohort = useZustandStore(
    (state) => state.lead?.cohort || state.initialCohort,
  )
  const language = useZustandSessionStore((state) => state.language)

  useEffect(() => {
    if (!cohort || !language) return

    getFirstLead()
  }, [cohort, language])
}
